<template>
  <button :class="direction" @click="emit('clickScroll')">
    <span class="arrow-container">
      <icon class="arrow" :name="`nomad:arrow-${direction}`" size="1rem" />
      <icon class="arrow over" :name="`nomad:arrow-${direction}`" size="1rem" />
    </span>
  </button>
</template>
<script setup lang="ts">
interface Props {
  direction: 'left' | 'right';
}

defineProps({
  direction: null
});

const emit = defineEmits(["clickScroll"]);
</script>
<style lang="scss" scoped>
.arrow-container {
  display: flex;
  position: relative;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  overflow: hidden;
}

.arrow {
  position: relative;
  z-index: 1;
  transition: transform 400ms $ease-out-back 0ms;
  color: var(--color_secondary_darker);

  &.over {
    position: absolute;
    top: calc(0.5 * (2.8rem - 1rem));
    left: calc(0.5 * (2.8rem - 1rem) - 2.8rem);
    transition: transform 200ms $ease-in-back 0ms;
  }
}
.left {
  .arrow {
    &.over {
      left: calc(0.5 * (2.8rem - 1rem) + 2.8rem);
    }
  }
}
button {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: scale(0.9);
    transition: transform 200ms $ease-out-back;
    border-radius: 50%;
    background-color: var(--color_neutral_25);
  }
  @include hover-focus-desktop {
    &::after {
      transform: scale(1);
    }
    .arrow {
      transform: translateX(2.8rem);
      transition: transform 200ms $ease-in-back;

      &.over {
        transform: translateX(2.8rem);
        transition: transform 200ms $ease-out-back 100ms;
      }
    }
    &.left {
      .arrow {
        transform: translateX(-2.8rem);
        &.over {
          transform: translateX(-2.8rem);
        }
      }
    }
  }
}
</style>
